import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, thirdWidth } from "../../blocks/layout/columnSpans";

/**
 * Event Profile as page config. The ticketing feed owns the event's details, so only
 * its type, season and fixture are edited and saved here. Name is the page title, and
 * the warehouse ignores it on update.
 */
export const eventProfilePageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "dweventprofile",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-event-details",
              title: "Event details",
              fields: [
                {
                  id: "field-eventcode",
                  type: "text",
                  name: "eventcode",
                  label: "Event Code",
                  readOnly: true,
                  excludeFromSave: true,
                  span: thirdWidth,
                },
                {
                  id: "field-start",
                  type: "datetime",
                  name: "start",
                  label: "Start",
                  storedAsLocal: true,
                  readOnly: true,
                  excludeFromSave: true,
                  span: thirdWidth,
                },
                {
                  id: "field-end",
                  type: "datetime",
                  name: "end",
                  label: "End",
                  storedAsLocal: true,
                  readOnly: true,
                  excludeFromSave: true,
                  span: thirdWidth,
                },
                {
                  id: "field-description",
                  type: "longtext",
                  name: "description",
                  label: "Description",
                  readOnly: true,
                  excludeFromSave: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-classification",
              title: "Classification",
              fields: [
                {
                  id: "field-typeid",
                  type: "lookup",
                  name: "typeid",
                  label: "Type",
                  lookupEntity: "dwtype",
                  searchable: true,
                  required: true,
                  span: fullWidth,
                },
                {
                  id: "field-seasonid",
                  type: "lookup",
                  name: "seasonid",
                  label: "Season",
                  lookupEntity: "dwseason",
                  searchable: true,
                  required: true,
                  span: fullWidth,
                },
                {
                  id: "field-fixtureid",
                  type: "lookup",
                  name: "fixtureid",
                  label: "Fixture",
                  lookupEntity: "dwfixture",
                  searchable: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
